export default {
    imageDashboardTransaction: {
        action: 'Azione',
        transactionId: 'ID della transazione',
        variationCount: 'Conteggio di variazione',
        date: 'Data',
        cost: 'Costo',
        description: 'Descrizione',
        selectedImage: 'Immagine selezionata',
        goTo: 'vai a',
    },
};
